import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Paper,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

function PrivateHome() {
  const history = useHistory();
  const { user, isAffiliate, refreshAuth } = useAuth();
  
  // Add useEffect to refresh auth when component mounts
  useEffect(() => {
    // Refresh auth to get the latest credit balance
    refreshAuth();
  }, [refreshAuth]);
  
  const features = [
    {
      title: 'Credits',
      description: 'View your credit balance and purchase history',
      action: () => history.push('/credits'),
      primary: true
    },
    {
      title: 'Crypt',
      description: 'Encrypt your executable files',
      action: () => history.push('/crypt')
    },
    {
      title: 'Profile',
      description: 'Manage your account settings and preferences',
      action: () => history.push('/profile')
    }
  ];

  // Add affiliate dashboard for affiliates
  if (isAffiliate) {
    features.push({
      title: 'Affiliate Dashboard',
      description: 'Manage your affiliate coupons and earnings',
      action: () => history.push('/affiliate')
    });
  }

  if (user?.is_admin) {
    features.push({
      title: 'Admin Panel',
      description: 'Manage users, transactions, and coupons',
      action: () => history.push('/admin'),
      color: 'secondary'
    });
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 6 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome{user?.username ? `, ${user.username}` : ''}!
        </Typography>

        <Grid container spacing={3} sx={{ mt: 3 }}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
                <CardActions sx={{ p: 2, pt: 0 }}>
                  <Button
                    fullWidth
                    variant={feature.primary ? "contained" : "outlined"}
                    color={feature.color || "primary"}
                    onClick={feature.action}
                    size="large"
                  >
                    {`Go to ${feature.title}`}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Paper sx={{ mt: 6, p: 3 }}>
          <Typography variant="h5" gutterBottom>
            Quick Stats
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography variant="subtitle1" color="text.secondary">
                  Credit Balance
                </Typography>
                <Typography variant="h4">
                  {user?.credits || 0} credits
                </Typography>
              </Box>
            </Grid>
            {isAffiliate && (
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <Typography variant="subtitle1" color="text.secondary">
                    Affiliate Status
                  </Typography>
                  <Typography variant="h4" color="success.main">
                    Active
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
}

export default PrivateHome; 